(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: window.Shopify?.currency?.active || "USD",
      }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/"/g, "&quot;");
  }

  function withWidth(url, width) {
    if (!url) return "";
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, "$1" + width);
    return url + (url.includes("?") ? "&" : "?") + "width=" + width;
  }

  function srcsetFrom(url) {
    return [400, 700, 1000, 1400]
      .map((w) => withWidth(url, w) + " " + w + "w")
      .join(", ");
  }

  const countdownEls = $$("[data-countdown]");
  function tickCountdowns() {
    countdownEls.forEach((el) => {
      const to = new Date(el.getAttribute("data-countdown"));
      if (Number.isNaN(to.getTime())) return;
      const diff = Math.max(0, to.getTime() - Date.now());
      const s = Math.floor(diff / 1000);
      const parts = [
        Math.floor(s / 86400),
        Math.floor((s % 86400) / 3600),
        Math.floor((s % 3600) / 60),
        s % 60,
      ];
      $$("[data-unit]", el).forEach((node, i) => {
        node.textContent = String(parts[i] ?? 0).padStart(2, "0");
      });
    });
  }
  if (countdownEls.length) {
    tickCountdowns();
    let timer = setInterval(tickCountdowns, 1000);
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        clearInterval(timer);
        timer = 0;
      } else if (!timer) {
        tickCountdowns();
        timer = setInterval(tickCountdowns, 1000);
      }
    });
  }

  const overlay = $(".drawer-overlay");
  const countEls = $$("[data-cart-count]");
  let cartLoaded = false;

  function setOpen(open) {
    document.body.classList.toggle("cart-open", open);
    if (open && !cartLoaded) refreshCart();
  }
  $$("[data-open-cart]").forEach((b) =>
    b.addEventListener("click", () => setOpen(true)),
  );
  $$("[data-close-cart]").forEach((b) =>
    b.addEventListener("click", () => setOpen(false)),
  );
  overlay?.addEventListener("click", () => setOpen(false));

  function renderCart(cart) {
    cartLoaded = true;
    countEls.forEach((n) => {
      n.textContent = String(cart.item_count);
      n.hidden = cart.item_count === 0;
    });
    const body = $("[data-cart-body]");
    const foot = $("[data-cart-foot]");
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="lede" style="font-size:1rem">Your bag is empty.</p>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items
      .map(
        (item) => `
      <div class="cart-line">
        <img src="${escapeHtml(withWidth(item.image || "", 160))}" alt="" width="80" height="80" loading="lazy" decoding="async">
        <div>
          <strong>${escapeHtml(item.product_title)}</strong>
          <div style="color:var(--muted);font-size:12px">${escapeHtml(item.variant_title || "")}</div>
          <div style="margin-top:8px;display:flex;justify-content:space-between;gap:8px">
            <span>${item.quantity} × ${money(item.final_line_price / Math.max(item.quantity, 1))}</span>
            <button data-remove="${escapeHtml(item.key)}" type="button">Remove</button>
          </div>
        </div>
      </div>`,
      )
      .join("");
    const total = $("[data-cart-total]");
    if (total) total.textContent = money(cart.total_price);
    $$("[data-remove]", body).forEach((btn) => {
      btn.addEventListener("click", async () => {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: btn.getAttribute("data-remove"), quantity: 0 }),
        });
        refreshCart();
      });
    });
  }

  async function refreshCart() {
    const cart = await fetch("/cart.js").then((r) => r.json());
    renderCart(cart);
    return cart;
  }

  $$("[data-add-form]").forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const data = new FormData(form);
      await fetch("/cart/add.js", { method: "POST", body: data });
      await refreshCart();
      setOpen(true);
    });
  });

  $$("[data-variant-btn]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const id = btn.getAttribute("data-variant-btn");
      const input = $("[data-variant-input]");
      if (input) input.value = id;
      $$("[data-variant-btn]").forEach((b) =>
        b.setAttribute("aria-pressed", String(b === btn)),
      );
      const price = btn.getAttribute("data-price");
      const node = $("[data-product-price]");
      if (price && node) node.textContent = money(Number(price));
    });
  });

  $$("[data-thumb]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const main = $(".product .media img");
      const url = btn.getAttribute("data-thumb");
      if (main && url) {
        main.src = url;
        main.srcset = srcsetFrom(url);
        main.sizes = "(min-width: 900px) 55vw, 100vw";
      }
      btn.parentNode.querySelectorAll("button").forEach((b) => b.removeAttribute("aria-current"));
      btn.setAttribute("aria-current", "true");
    });
  });

  $("[data-toggle-menu]")?.addEventListener("click", () => {
    document.body.classList.toggle("menu-open");
  });
  $("[data-toggle-search]")?.addEventListener("click", () => {
    document.body.classList.toggle("search-open");
    $("[data-search-input]")?.focus();
  });
})();
